var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground1100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 721,
    height: 800,
    viewBox: "0 0 721 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blurLarge",
    x: -400,
    y: -600,
    width: 2000,
    height: 2200,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    edgeMode: "duplicate"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blurMedium",
    x: -400,
    y: -600,
    width: 2000,
    height: 2200,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 194.75,
    edgeMode: "duplicate"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blurSmall",
    x: -200,
    y: -200,
    width: 1500,
    height: 1500,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    edgeMode: "duplicate"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blurLarge)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.569,
    cy: 358.85,
    rx: 472.569,
    ry: 546.85,
    fill: "#182347"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blurLarge)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.569,
    cy: 358.85,
    rx: 428.379,
    ry: 495.713,
    fill: "#4465D2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blurMedium)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.569,
    cy: 358.851,
    rx: 319.255,
    ry: 369.437,
    fill: "#4465D2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blurSmall)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.568,
    cy: 400.594,
    rx: 231.775,
    ry: 268.207,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground1100);
export default __webpack_public_path__ + "static/media/background-1100.be4b131a8749e89835608403299b183a.svg";
export { ForwardRef as ReactComponent };